module.exports = __webpack_public_path__ + "img/40.0cf4568b.jpg";